import { render } from "./WelcomeSplash.vue?vue&type=template&id=1348d69a&scoped=true"
const script = {}

import "./WelcomeSplash.vue?vue&type=style&index=0&id=1348d69a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1348d69a"]])

export default __exports__